// ** Type Import
import { OwnerStateThemeType } from "../";

const input = () => {
  /* 
        The input labels needed to be larger when shrunk 
        Legend (element that removes the border around the words when label is shrunk)
            This must also be increased so the border doesn't cutoff the words 
            It is not an exact match and a ratio was added after some testing
            Now we should only need to increase the inputLabelFontSize and it should update accordingly
    */
  const inputLabelToLegendFontSizeRatio = 0.73;

  const inputLabelFontSize = 1.2;

  const legendFontSize = inputLabelFontSize * inputLabelToLegendFontSizeRatio;

  return {
    MuiInputLabel: {
      styleOverrides: {
        root: ({ theme }: OwnerStateThemeType) => ({
          color: theme.palette.text.secondary,
          "&.MuiInputLabel-shrink": {
            fontSize: `${inputLabelFontSize}rem`,
          },
        }),
      },
    },
    MuiInput: {
      styleOverrides: {
        root: ({ theme }: OwnerStateThemeType) => ({}),
      },
    },
    MuiFilledInput: {
      styleOverrides: {
        root: ({ theme }: OwnerStateThemeType) => ({}),
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: ({ theme }: OwnerStateThemeType) => ({}),
        notchedOutline: {
          legend: {
            fontSize: `${legendFontSize}rem`,
          },
        },
      },
    },
  };
};

export default input;
